/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractResponseDto } from '../../models/sales-contract-response-dto';

export interface ContractsControllerFindByQuoteId$Params {
  quoteId: string;
}

export function contractsControllerFindByQuoteId(http: HttpClient, rootUrl: string, params: ContractsControllerFindByQuoteId$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractsControllerFindByQuoteId.PATH, 'get');
  if (params) {
    rb.path('quoteId', params.quoteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractResponseDto>;
    })
  );
}

contractsControllerFindByQuoteId.PATH = '/o2-sales/contracts/by-quote/{quoteId}';
